"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAXIMAL_QUIZ_ANSWERS = exports.MINIMAL_QUIZ_ANSWERS = exports.QuizPinSchema = exports.QuizStudentPinSettingsSchema = exports.QuizTeacherPinSettingsSchema = exports.QuizPinSettingsSchema = exports.QuizPinLayoutTemplateSchema = exports.QuizLayoutPartKeySchema = void 0;
const zod_1 = require("zod");
const pin_component_1 = require("../pin-component");
const layout_part_1 = require("../pin-component/layout-part");
const base_pin_1 = require("./base-pin");
const base_student_pin_1 = require("./base-student-pin");
const base_teacher_pin_1 = require("./base-teacher-pin");
const tiptap_content_schema_1 = require("../tiptap-content.schema");
const QuizPinAnswerImageSchema = zod_1.z.object({
    type: zod_1.z.literal('IMAGE'),
    id: zod_1.z.string().min(1),
    url: zod_1.z.string().min(1).optional(),
});
const QuizPinAnswerTextSchema = zod_1.z.object({
    type: zod_1.z.literal('TEXT'),
    id: zod_1.z.string().min(1),
    text: tiptap_content_schema_1.TipTapContentSchema,
});
const QuizPinAnswerSchema = zod_1.z.discriminatedUnion('type', [QuizPinAnswerImageSchema, QuizPinAnswerTextSchema]);
const QuizPinLayoutKeySchema = zod_1.z.enum(['IMAGE_LEFT', 'IMAGE_ONLY', 'IMAGE_RIGHT', 'TITLE_ONLY', 'EMPTY']);
exports.QuizLayoutPartKeySchema = layout_part_1.LayoutPartSchema.extract(['TITLE', 'IMAGE1']);
exports.QuizPinLayoutTemplateSchema = base_pin_1.BaseTemplateLayoutSchema.merge(zod_1.z.object({
    key: QuizPinLayoutKeySchema,
    layoutParts: zod_1.z.record(exports.QuizLayoutPartKeySchema, pin_component_1.PinComponentSchema.optional()),
}));
exports.QuizPinSettingsSchema = base_pin_1.BaseInteractiveQuestionPinSettingsSchema.merge(zod_1.z.object({
    answers: zod_1.z.array(QuizPinAnswerSchema),
    layout: QuizPinLayoutKeySchema,
    layoutParts: zod_1.z.record(exports.QuizLayoutPartKeySchema, zod_1.z.string().optional()),
}));
exports.QuizTeacherPinSettingsSchema = base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({
    correctAnswers: zod_1.z.array(zod_1.z.string()),
    // TODO: Unused?
    shuffleMap: zod_1.z.any().optional(), // shuffling answers (assessment (test) only)
}));
exports.QuizStudentPinSettingsSchema = base_student_pin_1.AnswerSettingSchema;
exports.QuizPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('MULTIPLE_CHOICE'),
    settings: exports.QuizPinSettingsSchema,
}));
exports.MINIMAL_QUIZ_ANSWERS = 2;
exports.MAXIMAL_QUIZ_ANSWERS = 4;
//# sourceMappingURL=quiz-pin.js.map